module.exports = __webpack_public_path__ + "static/media/2-MODIL.92be2ae6.mp3";